const API_URL =
    process.env.NODE_ENV === 'development'
        ? 'http://localhost:5000/api/code'
        : '/api/code';

/**
 * Execute code via the Piston backend.
 *
 * @param {{ language: string, code: string, stdin?: string }} params
 * @returns {Promise<{ success: boolean, stdout?: string, stderr?: string, compile_output?: string, execution_time?: string, memory?: string, error?: string }>}
 */
export const executeCode = async ({ language, code, stdin }) => {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 15000); // 15s client-side timeout

    try {
        const res = await fetch(`${API_URL}/run`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ language, code, stdin }),
            signal: controller.signal,
        });

        clearTimeout(timeout);
        const data = await res.json();

        if (!res.ok) {
            return {
                success: false,
                error: data.error || `Server error (${res.status})`,
            };
        }

        return data;
    } catch (err) {
        clearTimeout(timeout);

        if (err.name === 'AbortError') {
            return {
                success: false,
                error: 'Request timed out. The server may be overloaded.',
            };
        }

        return {
            success: false,
            error: 'Network error. Please check your connection and try again.',
        };
    }
};
